export enum ProducInfoEnum {
  Description = 1,
  Features,
};